export function opportunityId(opportunity) {
  if (!opportunity || typeof opportunity !== "object") return null;
  return opportunity.noticeId || opportunity.notice_id || null;
}

export function isOpportunitySaved(saved, opportunity) {
  const id = opportunityId(opportunity);
  return Boolean(id && saved instanceof Set && saved.has(id));
}

export function mergeSavedOpportunities(searchPage = [], savedRecords = []) {
  const searchById = new Map(
    searchPage
      .map(opportunity => [opportunityId(opportunity), opportunity])
      .filter(([id]) => id)
  );
  const mergedById = new Map();

  savedRecords.forEach(savedRecord => {
    const id = typeof savedRecord === "string" ? savedRecord : opportunityId(savedRecord);
    if (!id || mergedById.has(id)) return;

    const searchRecord = searchById.get(id);
    if (typeof savedRecord === "string") {
      if (searchRecord) mergedById.set(id, searchRecord);
      return;
    }

    mergedById.set(id, searchRecord ? { ...searchRecord, ...savedRecord } : savedRecord);
  });

  return [...mergedById.values()];
}
